<template>
  <div class="bottombar">
    <div style="margin-right: 20px; margin-left: 20px">当前经度:{{ lng }}</div>
    <div>当前纬度:{{ lat }}</div>
  </div>
</template>

<script>
export default {
  name: "full",
  data() {
    return {
      lng: 0,
      lat: 0,
    };
  },
  methods: {},
  mounted() {
    const handler = new map3d.Event.MouseHandler();
    handler.add("MOUSE_MOVE", (movement) => {
      const position = handler.getCoordinates(movement);
      if (position && position[0] && position[1]) {
        this.lng = position[0].toFixed(4);
        this.lat = position[1].toFixed(4);
      }
    });
  },
};
</script>

<style scoped>
.bottombar {
  color: white;
  position: absolute;
  left: 0%;
  cursor: pointer;
  font-size: 20px;
  top: 96%;
  height: 40px;
  line-height: 40px;
  background: #000;
  width: 100%;
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/bottombar.vue